import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { AuthModal } from '../auth/AuthModal';
import { ChevronRightIcon, UsersIcon, TrendingUpIcon, DollarSignIcon, BarChartIcon } from 'lucide-react';
export const AffiliateProgram = () => {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    user,
    addRole
  } = useAuth();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const handleJoinNow = () => {
    // Check if user is authenticated
    if (!isAuthenticated) {
      // Open signup modal directly
      setAuthModalOpen(true);
      return;
    }
    // Add affiliate role to the user
    addRole('affiliate');
    // Then navigate to the affiliate dashboard
    navigate('/affiliate-dashboard');
  };
  return <div className="w-full bg-white dark:bg-[#0F1F1D] min-h-screen" data-id="element-143">
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-144">
        <div className="absolute inset-0 bg-gradient-to-br from-[#F8FAF9]/80 to-[#F8FAF9] dark:from-[#0F1F1D]/80 dark:to-[#0F1F1D] z-0" data-id="element-145"></div>
        {/* Background Decorations */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-146">
          <div className="absolute top-[10%] right-[5%] w-[300px] h-[300px] rounded-full bg-[#2DB489]/10 dark:bg-[#2DB489]/5 blur-3xl" data-id="element-147"></div>
          <div className="absolute bottom-[10%] left-[5%] w-[250px] h-[250px] rounded-full bg-[#0D3C45]/10 dark:bg-[#0D3C45]/5 blur-3xl" data-id="element-148"></div>
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-149">
          <div className="max-w-4xl mx-auto text-center" data-id="element-150">
            <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-transparent bg-clip-text" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-151">
              Earn While You Share
            </motion.h1>
            <motion.p className="text-xl md:text-2xl text-[#1F2F35] dark:text-[#C4D1CC] mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} data-id="element-152">
              Join our Affiliate Program and earn up to 30% commission on every
              sale you refer
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-153">
              <button onClick={handleJoinNow} className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-white px-8 py-4 rounded-full text-lg font-medium hover:shadow-xl transition-all transform hover:scale-103 relative overflow-hidden button-hover-effect dark-glow" data-id="element-154">
                <span className="relative z-10" data-id="element-155">Join Now</span>
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 md:py-24 bg-[#F8FAF9] dark:bg-[#0F1F1D]" data-id="element-156">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-158">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-159">
              Why Become an Affiliate?
            </h2>
            <p className="text-lg text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-160">
              Our affiliate program is designed to reward you generously while
              providing all the tools you need to succeed
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-161">
            <div className="bg-white dark:bg-[#162825] p-8 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] transition-transform hover:transform hover:scale-105" data-id="element-162">
              <div className="w-14 h-14 bg-[#2DB489]/10 dark:bg-[#2DB489]/20 rounded-full flex items-center justify-center mb-6" data-id="element-163">
                <DollarSignIcon className="h-7 w-7 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-164" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-165">
                High Commissions
              </h3>
              <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-166">
                Earn up to 30% commission on every sale you refer through your
                unique affiliate link
              </p>
            </div>
            <div className="bg-white dark:bg-[#162825] p-8 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] transition-transform hover:transform hover:scale-105" data-id="element-167">
              <div className="w-14 h-14 bg-[#2DB489]/10 dark:bg-[#2DB489]/20 rounded-full flex items-center justify-center mb-6" data-id="element-168">
                <BarChartIcon className="h-7 w-7 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-169" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-170">
                Real-Time Analytics
              </h3>
              <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-171">
                Track your performance with detailed analytics and reporting
                tools
              </p>
            </div>
            <div className="bg-white dark:bg-[#162825] p-8 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] transition-transform hover:transform hover:scale-105" data-id="element-172">
              <div className="w-14 h-14 bg-[#2DB489]/10 dark:bg-[#2DB489]/20 rounded-full flex items-center justify-center mb-6" data-id="element-173">
                <UsersIcon className="h-7 w-7 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-174" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-175">
                Dedicated Support
              </h3>
              <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-176">
                Get personalized support and resources to help you maximize your
                earnings
              </p>
            </div>
            <div className="bg-white dark:bg-[#162825] p-8 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] transition-transform hover:transform hover:scale-105" data-id="element-177">
              <div className="w-14 h-14 bg-[#2DB489]/10 dark:bg-[#2DB489]/20 rounded-full flex items-center justify-center mb-6" data-id="element-178">
                <TrendingUpIcon className="h-7 w-7 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-179" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-180">
                Recurring Commissions
              </h3>
              <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-181">
                Earn passive income with recurring commissions on
                subscription-based products
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-16 md:py-24" data-id="element-182">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-184">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-185">
              How It Works
            </h2>
            <p className="text-lg text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-186">
              Getting started is simple. Follow these steps to begin earning
              commissions
            </p>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-187">
            <div className="relative" data-id="element-188">
              {/* Vertical line */}
              <div className="absolute left-[22px] top-0 bottom-0 w-1 bg-gradient-to-b from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] hidden md:block" data-id="element-189"></div>
              <div className="space-y-12" data-id="element-190">
                <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-191">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] flex items-center justify-center text-white font-bold text-lg z-10" data-id="element-192">
                    1
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-6 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] flex-1" data-id="element-193">
                    <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-194">
                      Join the Program
                    </h3>
                    <p className="text-[#4A686C] dark:text-[#7A8F8A] mb-4" data-id="element-195">
                      Sign up for our affiliate program by clicking the "Join
                      Now" button. It's free and only takes a minute.
                    </p>
                    <button onClick={handleJoinNow} className="text-[#2DB489] dark:text-[#4ED1A0] font-medium flex items-center hover:underline" data-id="element-196">
                      Get Started <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-197" />
                    </button>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-198">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] flex items-center justify-center text-white font-bold text-lg z-10" data-id="element-199">
                    2
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-6 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] flex-1" data-id="element-200">
                    <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-201">
                      Get Your Unique Link
                    </h3>
                    <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-202">
                      Once approved, you'll receive your unique affiliate link
                      and promotional materials from your dashboard.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-203">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] flex items-center justify-center text-white font-bold text-lg z-10" data-id="element-204">
                    3
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-6 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] flex-1" data-id="element-205">
                    <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-206">
                      Share & Promote
                    </h3>
                    <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-207">
                      Share your affiliate link on your website, social media,
                      or through email marketing to your audience.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-208">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] flex items-center justify-center text-white font-bold text-lg z-10" data-id="element-209">
                    4
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-6 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] flex-1" data-id="element-210">
                    <h3 className="text-xl font-semibold mb-3 text-[#0D3C45] dark:text-[#F8FAF9]" data-id="element-211">
                      Earn Commissions
                    </h3>
                    <p className="text-[#4A686C] dark:text-[#7A8F8A]" data-id="element-212">
                      Earn up to 30% commission on every sale made through your
                      affiliate link. Payments are made monthly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#162825] dark:to-[#267A67]" data-id="element-213">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
          <div className="max-w-4xl mx-auto text-center" data-id="element-215">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-216">
              Ready to Start Earning?
            </h2>
            <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto" data-id="element-217">
              Join thousands of successful affiliates who are already earning
              commissions by promoting our products
            </p>
            <button onClick={handleJoinNow} className="bg-white text-[#0D3C45] dark:text-[#267A67] px-8 py-4 rounded-full text-lg font-medium hover:shadow-xl transition-all transform hover:scale-103" data-id="element-218">
              Join Our Affiliate Program
            </button>
          </div>
        </div>
      </section>

      {/* Auth Modal */}
      <AuthModal isOpen={authModalOpen} onClose={() => setAuthModalOpen(false)} initialMode="signup" redirectTo="/affiliate-dashboard" data-id="element-219" />
    </div>;
};